import { ChangeDetectionStrategy, Component, OnInit } from "@angular/core";
import { filterAllTruthyInTuple } from "core/rx-js";
import { combineLatest } from "rxjs";
import { DataSourceControlService, OptionTemplateService } from "../../data-source-utils";
import mapItemDisplay from "../../form-rx-js/map-item-display";
import mapTemplateValue from "../../form-rx-js/map-template-value";


@Component({
  selector: 'ss-template-select-trigger',
  templateUrl: './template-select-trigger.component.html',
  styleUrls: ['./template-select-trigger.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TemplateSelectTriggerComponent implements OnInit {

  readonly matTemplateTypeObs = this._optionTemplateService.matTemplateTypeObs;
  readonly templateSubject = this._optionTemplateService.templateSubject;
  readonly displayExprSubject = this._optionTemplateService.displayExprSubject
  readonly selectedItemSubject = this._dataSourceControlService.selectedItemSubject;

  readonly displayObs = combineLatest([
    this._optionTemplateService.displayExprSubject,
    this.selectedItemSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      mapItemDisplay()
    )

  readonly matOptionTemplateValuesObs = combineLatest([
    this.templateSubject,
    this.selectedItemSubject
  ])
    .pipe(
      filterAllTruthyInTuple(),
      mapTemplateValue()
    )


  constructor(
    private _optionTemplateService: OptionTemplateService,
    private _dataSourceControlService: DataSourceControlService
  ) { }


  ngOnInit(): void {
  }

}
